import React from 'react'
import { cn } from '../../lib/utils';

interface ConfigurationHeadingProps {
    title: string;
    className?: string;
}

function ConfigurationHeading({ title, className }: ConfigurationHeadingProps) {
    return (
        <h2 className={cn("truncate text-sm 2xl:text-base font-semibold leading-[1.2] text-grey-700 dark:text-foreground", className)}>
            {title}
        </h2>
    );
}


export default ConfigurationHeading;